"use client"

import * as React from "react"

import type { FeatureTutorialDto } from "@/features/product-features/model/product-feature-types"

export type FeatureTutorialState = {
  featureKey: string
  tutorial: FeatureTutorialDto
  /** The operator's title, or the generic "see how this page works". */
  title: string
  dismissed: boolean
  setDismissed: (dismissed: boolean) => void
  openVideo: () => void
  /**
   * The page header currently showing the tutorial (the first one in document order), or null when no header
   * on the page can, in which case the layout shows it instead. One owner, so it is never shown twice.
   */
  ownerHeaderId: string | null
  registerHeader: (headerId: string, anchor: HTMLElement) => () => void
}

export const FeatureTutorialContext = React.createContext<FeatureTutorialState | null>(null)

/** The current page's tutorial, or null when it has none (most pages, most of the time). */
export function useFeatureTutorial(): FeatureTutorialState | null {
  return React.useContext(FeatureTutorialContext)
}

